export enum Steps {
    Toestellen = 1,
    Type = 2,
    Design = 3,
    Functies = 4,
    Integraties = 5,
    Offline = 6,
    Notificaties = 7,
    Gegevens = 8,
}